import { put, select } from 'redux-saga/effects';
import { scheduleActions } from '../../../pages/data/organization/crew-scheduling-v3/redux-saga/actions';
import { Issue } from '../../../common/types/CombinedEntry';
import { CrewScheduleTimelineEntry } from '../../../common/types/timeline/CrewScheduleTimelineEntry';
import { getCrewScheduleTimelineEntries } from '../../../pages/data/organization/crew-scheduling-v3/redux-saga/selectors';

function* getOtherEntriesWithViolations(allEntries: CrewScheduleTimelineEntry[], entry: CrewScheduleTimelineEntry) {
  return allEntries.filter(
    e => e?.UserID === entry?.UserID && e?.ID !== entry?.ID && e?.Issues?.length > 0
  );
}

function* updateViolationsState(
  crewScheduleViolations: { [userID: string]: Issue[] },
  userId: string,
  violations: Issue[] | null
) {
  const updatedViolations = { ...crewScheduleViolations };

  if (violations === null) {
    delete updatedViolations[userId];
  } else {
    updatedViolations[userId] = violations;
  }

  yield put(
    scheduleActions.setState({
      crewScheduleViolations: updatedViolations,
    }),
  );
}

export function* updateCrewScheduleViolations(
  entry: CrewScheduleTimelineEntry,
  crewScheduleViolations: {
    [userID: string]: Issue[];
  },
  isEntryToDelete: boolean = false,
) {
  const allEntries = yield select(getCrewScheduleTimelineEntries);
  const otherEntriesWithViolations = yield* getOtherEntriesWithViolations(allEntries, entry);

  if (isEntryToDelete || !entry?.Issues || entry?.Issues?.length === 0) {
    if (otherEntriesWithViolations.length > 0) {
      const allViolations = otherEntriesWithViolations.flatMap(e => e.Issues || []);
      yield* updateViolationsState(crewScheduleViolations, entry?.UserID, allViolations);
    } else {
      yield* updateViolationsState(crewScheduleViolations, entry?.UserID, null);
    }
    return;
  }

  const allViolations = [
    ...entry?.Issues,
    ...otherEntriesWithViolations.flatMap(e => e?.Issues || [])
  ];

  yield* updateViolationsState(crewScheduleViolations, entry?.UserID, allViolations);
}
